module.exports = __webpack_public_path__ + "media/images/icons/pdf-253e7aa32094f5ddcd44d204e055ec61.svg";